export const SITE_URL = "https://wewonderevents.com";

export const NAV_LINKS = [
  { label: "Home", href: `${SITE_URL}/` },
  { label: "About Us", href: `${SITE_URL}/about-us/` },
  { label: "Services", href: "/services" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact Us", href: "/contact" },
];

export const SERVICE_CATEGORIES = [
  {
    id: "corporate",
    title: "Corporate Events",
    icon: "Briefcase",
    description:
      "End-to-end corporate event solutions designed to engage audiences, strengthen brands and deliver seamless experiences.",
    services: [
      "Product Launches",
      "MICE",
      "Trainings & Workshops",
      "Dealers Meets",
      "Official Meets",
      "HR Engagement Events",
      "Experiential Marketing / Activations",
      "Exhibition Solutions",
      "Venue Management",
      "PR",
      "Merchandising",
      "Family Day Celebrations",
    ],
  },
  {
    id: "government",
    title: "Government & PSU Events",
    icon: "Landmark",
    description:
      "Professional planning and execution for conferences, exhibitions, official functions and specialized government and PSU events.",
    services: [
      "Conferences & Seminars",
      "Annual Day Celebrations",
      "Defence Special Events",
      "Exhibitions / Stalls",
      "Annual General Meetings",
      "Launch Events",
      "Award Functions",
      "Sports Events",
      "G2B & G2C Events",
    ],
  },
  {
    id: "artists",
    title: "Artists & Entertainment",
    icon: "Mic2",
    description:
      "Memorable entertainment experiences featuring live performances, artists, theme shows and celebrity appearances.",
    services: [
      "Theme Shows",
      "Live Performances",
      "Award Nights",
      "Star Nights / Concerts",
      "Fashion Shows",
      "Celebrity Appearance & Management",
      "Artist Workshops",
    ],
  },
  {
    id: "creative",
    title: "Creative Solutions",
    icon: "Palette",
    description:
      "Creative branding, production, design and visual solutions that bring ideas to life and make every event stand out.",
    services: [
      "Customized Branding Solutions",
      "Customized Backdrops 360°",
      "Film Production — Corporate & Documentary Films",
      "Corporate / Product Shoots",
      "Merchandising",
      "Advertising Solutions",
      "Multi-Projection Systems",
      "Motion Graphics",
      "3D Mapping",
      "3D & 2D Graphic Solutions",
      "Website Designing",
    ],
  },
  {
    id: "digital",
    title: "Digital Solutions",
    icon: "Cpu",
    description:
      "Digital marketing, web development and interactive technology solutions designed to strengthen online presence and engagement.",
    services: [
      "Digital Interactive Activities",
      "Digital Marketing",
      "Website Development",
      "Content Design & Development",
      "SMO",
      "SEO & ORM",
      "Hosting & Domain Services",
      "Web Applications",
      "Mobile Apps — All Platforms",
      "E-Commerce Applications",
      "Payment Gateway",
      "Augmented & Virtual Reality",
      "SMS & Email Marketing",
      "Maintenance & Support Services",
    ],
  },
  {
    id: "social",
    title: "Social Events",
    icon: "Heart",
    description:
      "Beautifully planned celebrations for weddings, birthdays, anniversaries and special family occasions, creating memories to cherish.",
    services: [
      "Wedding",
      "Reception",
      "Anniversary",
      "Birthday Party",
      "Thread Ceremony",
      "Family Get Together / Reunion Party",
      "Funeral",
      "Home Warming",
      "Foundation Stone Ceremony",
    ],
  },
];

const IMG = "https://wewonderevents.com/wp-content/uploads";

export const WHAT_WE_DO = [
  {
    title: "Corporate Events",
    text: "From concept to execution, we handle every detail to create seamless and memorable events.",
    image: `${IMG}/2026/09/OASME-41st-.jpeg`,
  },
  {
    title: "Government & PSU Events",
    text: "We plan and execute conferences, seminars, exhibitions, annual events, award functions and other specialized government and PSU events with professional precision.",
    image: `${IMG}/2026/07/govt.events1.jpeg`,
  },
  {
    title: "Artists & Entertainment",
    text: "From live performances to theme shows and celebrity appearances, we create memorable entertainment experiences that captivate audiences.",
    image: `${IMG}/2026/07/live-show.jpeg`,
  },
  {
    title: "Creative Solutions",
    text: "Creative branding, production, design and visual solutions that bring your ideas to life and make every event stand out.",
    image: `${IMG}/2026/08/Agrayodhi-1.jpeg`,
  },
  {
    title: "Digital Solutions",
    text: "Digital marketing, web development and interactive technology solutions designed to strengthen your online presence and engagement.",
    image: `${IMG}/2026/09/KOICA.jpeg`,
  },
  {
    title: "Social Events",
    text: "Beautifully planned celebrations for weddings, birthdays, anniversaries and special family occasions, creating memories to cherish.",
    image: `${IMG}/2026/08/1-3.jpg`,
  },
];

export const HERO_IMAGE = `${IMG}/2026/09/OASME-41st-.jpeg`;

export const WHY_CHOOSE = [
  {
    icon: "Award",
    title: "18+ Years of Experience",
    text: "Extensive experience delivering diverse events and experiences.",
  },
  {
    icon: "Workflow",
    title: "End-to-End Execution",
    text: "From planning and creative development to production and execution.",
  },
  {
    icon: "Lightbulb",
    title: "Creative & Innovative Solutions",
    text: "Fresh ideas, innovative technology and customized event concepts.",
  },
  {
    icon: "Users",
    title: "Professional Team",
    text: "Experienced professionals focused on precision and seamless execution.",
  },
  {
    icon: "MapPin",
    title: "Pan-India Experience",
    text: "Experience working across diverse locations and event environments.",
  },
  {
    icon: "HeartHandshake",
    title: "Client-Centric Approach",
    text: "Every event is planned around the client's vision, goals and audience.",
  },
];

export const APPROACH_STEPS = [
  {
    step: "01",
    title: "Understand",
    text: "Understanding the client's vision, objectives and requirements.",
  },
  {
    step: "02",
    title: "Conceptualize",
    text: "Developing creative concepts and innovative event solutions.",
  },
  {
    step: "03",
    title: "Plan",
    text: "Detailed planning, coordination, budgeting and logistics.",
  },
  {
    step: "04",
    title: "Execute",
    text: "Professional on-ground execution with attention to every detail.",
  },
  {
    step: "05",
    title: "Deliver",
    text: "Creating memorable experiences that exceed expectations.",
  },
];
